import { render, staticRenderFns } from "./ListRestaurantAdmin.vue?vue&type=template&id=72355b30"
import script from "./ListRestaurantAdmin.vue?vue&type=script&lang=js"
export * from "./ListRestaurantAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListRestaurantAdmin.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72355b30')) {
      api.createRecord('72355b30', component.options)
    } else {
      api.reload('72355b30', component.options)
    }
    module.hot.accept("./ListRestaurantAdmin.vue?vue&type=template&id=72355b30", function () {
      api.rerender('72355b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListRestaurantAdmin.vue"
export default component.exports